import { jsx as _jsx } from "react/jsx-runtime";
export function TableRow(_ref) {
  var {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("tr", {
    className: "prezly-slate-table-row",
    children: children
  });
}